import React from 'react'

interface CheckboxGroupProps {
  options: string[]
  selected: string[]
  onChange: (selected: string[]) => void
  columns?: 2 | 3 | 4
  showSelectAll?: boolean
}

export default function CheckboxGroup({ options, selected, onChange, columns = 2, showSelectAll = false }: CheckboxGroupProps) {
  const handleToggle = (option: string) => {
    if (selected.includes(option)) {
      onChange(selected.filter(s => s !== option))
    } else {
      onChange([...selected, option])
    }
  }

  const handleSelectAll = () => {
    if (selected.length === options.length) {
      // All selected, so deselect all
      onChange([])
    } else {
      // Select all
      onChange([...options])
    }
  }

  const allSelected = selected.length === options.length && options.length > 0

  const gridClass = {
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4'
  }[columns]

  return (
    <div>
      <div className={`grid ${gridClass} gap-2`}>
        {options.map(option => (
          <label
            key={option}
            className="flex items-center gap-2 p-2 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
          >
            <input
              type="checkbox"
              checked={selected.includes(option)}
              onChange={() => handleToggle(option)}
              className="w-4 h-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-500"
            />
            <span className="text-sm text-gray-700">{option}</span>
          </label>
        ))}
      </div>
      {showSelectAll && options.length > 1 && (
        <label className="flex items-center gap-2 p-2 mt-2 rounded-lg bg-emerald-50 hover:bg-emerald-100 cursor-pointer transition-colors border border-emerald-200">
          <input
            type="checkbox"
            checked={allSelected}
            onChange={handleSelectAll}
            className="w-4 h-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-500"
          />
          <span className="text-sm font-medium text-emerald-700">Select all of the above</span>
        </label>
      )}
    </div>
  )
}
